import axios from 'axios';

const baseURL = 'api/Municipio/byProvincia';

async function getMunicipios(idProvincia) {
    const { data } = await axios.get(baseURL + "?idProvincia=" + idProvincia);
    return data;
}

export default { getMunicipios }